/** /admin/reports/cash-bank — Cash & Bank Book. */
import { Wallet } from 'lucide-react';
import { BalancesReport } from '../../components/BalancesReport';
export default function CashBankPage() {
  return <BalancesReport title="Cash & Bank Book" endpoint="/api/tally-import/cash-bank" icon={Wallet} emptyText="No cash or bank ledgers with a balance in this period." />;
}
